import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Button, Chip, IconButton, Alert, CircularProgress,
  ToggleButtonGroup, ToggleButton
} from '@mui/material';
import {
  Archive as ArchiveIcon, Unarchive as RestoreIcon,
  Refresh as RefreshIcon
} from '@mui/icons-material';
import axios from 'axios';

const API = '/api';
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const Archive = () => {
  const [annees, setAnnees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState('active');
  const [message, setMessage] = useState(null);

  const fetchAnnees = useCallback(async () => {
    setLoading(true);
    try {
      const filter = view === 'all' ? '' : `?archived=${view === 'archived'}`;
      const res = await axios.get(`${API}/archive/annees${filter}`, { headers: authHeaders() });
      if (res.data.success) setAnnees(res.data.data);
    } catch (err) {
      setMessage({ type: 'error', text: 'Erreur chargement' });
    }
    setLoading(false);
  }, [view]);

  useEffect(() => { fetchAnnees(); }, [fetchAnnees]);

  const handleArchive = async (id, intitule) => {
    if (!window.confirm(`Archiver ${intitule} ?`)) return;
    try {
      const res = await axios.post(`${API}/archive/annee/${id}`, {}, { headers: authHeaders() });
      setMessage({ type: 'success', text: res.data.message });
      fetchAnnees();
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.message || 'Erreur' });
    }
  };

  const handleRestore = async (id, intitule) => {
    if (!window.confirm(`Restaurer ${intitule} ?`)) return;
    try {
      const res = await axios.post(`${API}/archive/annee/${id}/restore`, {}, { headers: authHeaders() });
      setMessage({ type: 'success', text: res.data.message });
      fetchAnnees();
    } catch (err) {
      setMessage({ type: 'error', text: err.response?.data?.message || 'Erreur' });
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" fontWeight="bold" sx={{ color: '#1f2937' }}>Archivage</Typography>
        <IconButton onClick={fetchAnnees}><RefreshIcon /></IconButton>
      </Box>

      {message && <Alert severity={message.type} sx={{ mb: 2 }} onClose={() => setMessage(null)}>{message.text}</Alert>}

      <Box sx={{ mb: 3 }}>
        <ToggleButtonGroup value={view} exclusive onChange={(e, v) => v && setView(v)} size="small">
          <ToggleButton value="active" sx={{ textTransform: 'none' }}>Actives</ToggleButton>
          <ToggleButton value="archived" sx={{ textTransform: 'none' }}>Archivées</ToggleButton>
          <ToggleButton value="all" sx={{ textTransform: 'none' }}>Toutes</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: '#f9fafb' }}>
              <TableCell sx={{ fontWeight: 600 }}>Intitulé</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Période</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Statut</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow><TableCell colSpan={4} align="center" sx={{ py: 4 }}><CircularProgress size={24} /></TableCell></TableRow>
            ) : annees.length === 0 ? (
              <TableRow><TableCell colSpan={4} align="center" sx={{ py: 4, color: '#9ca3af' }}>Aucune année</TableCell></TableRow>
            ) : annees.map(a => (
              <TableRow key={a._id} hover>
                <TableCell sx={{ fontWeight: 500 }}>{a.intitule}</TableCell>
                <TableCell>{new Date(a.dateDebut).getFullYear()} - {new Date(a.dateFin).getFullYear()}</TableCell>
                <TableCell>
                  {a.archive ? (
                    <Chip label="Archivée" size="small" color="warning" variant="outlined" />
                  ) : a.estActive ? (
                    <Chip label="Active" size="small" color="success" variant="outlined" />
                  ) : (
                    <Chip label="Inactive" size="small" variant="outlined" />
                  )}
                </TableCell>
                <TableCell>
                  {a.archive ? (
                    <Button size="small" variant="outlined" color="warning" startIcon={<RestoreIcon />}
                      onClick={() => handleRestore(a._id, a.intitule)}>Restaurer</Button>
                  ) : (
                    <Button size="small" variant="outlined" color="warning" startIcon={<ArchiveIcon />}
                      onClick={() => handleArchive(a._id, a.intitule)}>Archiver</Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Archive;


